import React from 'react';
import '../template-file-css/document-file-template.css';


export const NP_UnitReq = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NP_UnitReq' className='file-pdf-document'>
            <div className='file-template'>
            <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Request: </span>
                            <input type="date" id="DateOfRequest" name="DateOfRequest" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Individual Name:</span>
                            <input type="text" id="txtIndividual" name="txtIndividual" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Birth:</span>
                            <input type="date" id="DateOfBirth" name="DateOfBirth" className='add-only' />
                        </td>
                    </tr>

                    
                    <tr>
                       
                        <td className='w-750'>
                            <span className='eleHeader'>Service Code:</span>
                            <input type="text" id="ServiceCode" name="ServiceCode" className='add-only' placeholder='Not Selected yet'/>
                        </td>
                    </tr>

                   
                   <tr>
                       <td className='w-750'>
                        <span className='eleHeader'>Place of Service:</span>
                        
                                <select id="PlaceOfService" name="PlaceOfService" className="add-only" >
                                <option value="" > *Select Location*</option>
                                   
                                </select>
                            </td>
                    </tr>

                       
                    <tr>
                       
                        <td className='w-250'>
                            <span className='eleHeader'>Start Time:</span>
                            <input type="time" id="StartTime" name="StartTime" className='add-only' />
                        </td>

                        
                        <td className='w-250'>
                            <span className='eleHeader'>End Time:</span>
                            <input type="time" id="EndTime" name="EndTime" className='add-only' />
                        </td>

                        
                        <td className='w-250'>
                            <span className='eleHeader'>Service Units Used:</span>
                            <input type="text" id="ServiceUnitsUsed" name="ServiceUnitsUsed" className='add-only' />
                        </td>
                    </tr>


                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>PROGRESS NOTE: </span></td>
                    </tr>
                    <p>
                        (Pls check as appropriate to indicate  IF form was completed as part session:
                    </p>
                
                
                <p>
                    <input type="radio" id="indicate_completed_yes" name="indicate_completed"  className='add-only' value="Yes" /> Billable   &nbsp;
                    <input type="radio" id="indicate_completed_No" name="indicate_completed" className='add-only' value="No" /> Non-Billable
                </p>

                <p>
                    Reauthorization/Unit Request form was completed in session today. Individual participated and agreed to treatment recommendations.

                </p>

                <tr>
                     <td className='w-750'><span className='eleHeader'>Does the member have a Primary Care Physician (PCP)  </span></td>
                </tr>

                <p>
                    <input type="radio" id=" Primary_Care_Physician_yes" name="Primary_Care_Physician"  className='add-only' value="Yes" /> Yes   &nbsp;
                    <input type="radio" id="Primary_Care_Physician_No" name="Primary_Care_Physician" className='add-only' value="No" /> No?
                </p>

                <p>
                    <span className='eleHeader'>Individual PCP: </span>
                    <span className='small'>
                         ( PCP Name and Telephone number needed):
                    </span>
                    
                    <textarea id="txt_PCP_Name_Telephone" name="txt_PCP_Name_Telephone" className='add-only'></textarea>
                </p>

            </table>

            <h3>
                <strong>Diagnosis: </strong>
                (Please list the Diagnosis ICD Codes :) 
            </h3>
            
            
            <h3>
                EMR – Pls populate from client data 
            </h3>

            <p>
                    <span className='eleHeader'>Risk of Harm:  </span>
                    <span className='small'>
                     (has Individual made suicidal/homicidal ideations or threats?:  If so, when was the last occurrence, history of SI/HI frequency, what triggered the ideation/threat? What steps were taken to resolve the situation? Is there any history of physical or sexual abuse? If so was the individual the victim or perpetrator? Was the abuse reported?)
                    </span>
                    <input type="radio" id="RiskOfHarm_No" name="RiskOfHarm" className='add-only' value="No" /> No<br/>
                    
                    <input type="radio" id=" RiskOfHarm_yes" name="RiskOfHarm"  className='add-only' value="Yes" /> Yes (Pls explain)   &nbsp;
                    <textarea id="txt_RiskOfHarm" name="txt_RiskOfHarm" className='add-only'></textarea>
                </p>


                <p>
                    <span className='eleHeader'>Functional Status:  </span>
                    <span className='small'>
                    (Ability to meet basic needs, fulfill usual role, and maintain health and wellness)
                    </span>

                    <textarea id="txt_FunctionalStatus" name="txt_FunctionalStatus" className='add-only'></textarea>
                </p>

                
                <p>
                    <span className='eleHeader'>Co-morbidities:   </span>
                    <span className='small'>
                    Symptoms and TX for medical/SUD diagnosis in addition to primary HX
                    </span>

                    <textarea id="txt_CoMorbidities" name="txt_CoMorbidities" className='add-only'></textarea>
                </p>

                
                <p>
                    <span className='eleHeader'>Environmental Stressors:    </span>
                    <span className='small'>
                    stress in the environment such as home, school, and work that interfere with the member's wellbeing
                    </span>

                    <textarea id="txt_Environmental_Stressors" name="txt_Environmental_Stressors" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Natural Support in the Environment:     </span>
                    <span className='small'>
                    Personal associations and relationships in the community that enhance the quality and security of the member
                    </span>

                    <textarea id="txt_Natural_Support_Environment" name="txt_Natural_Support_Environment" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Response to Current Treatment and Definition of Discharge Goals:      </span>
                    <span className='small'>
                    please indicate if the Individual’s response to treatment is Minimal, Moderate or Significant. If his/her response is Minimal, please indicate how the treatment plan will be adjusted to help improve his/her response to treatment, plans for transition and discharge
                    </span>

                    <textarea id="txt_Current_Treatment" name="txt_Current_Treatment" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Level of Care: Acceptance and Engagement:      </span>
                    <span className='small'>
                    How well has the Individual accepted his/her responsibility for change? How has he/she engaged in applying his/her treatment to daily living? What stage of change is the Individual currently in: Pre-Contemplative, Contemplative, Preparation, Action or Maintenance? If the Individual is in any stage less than Maintenance, what steps are recommended that he/she take to reach the next Stage of Change?)
                    </span>

                    <textarea id="txt_Acceptance_and_Engagement" name="txt_Acceptance_and_Engagement" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>History:    </span>
                    <span className='small'>
                    (Describe the precipitating events: include the onset of the problem, duration, frequency , past intervention/services and the results of  the services )
                    </span>

                    <textarea id="txt_History" name="txt_History" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Presenting Problem -    </span>
                    <span className='small'>
                       why individual was referred for  services?
                    </span>

                    <textarea id="txt_Presenting_Problem" name="txt_Presenting_Problem" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Ongoing Problem -   </span>
                    <span className='small'>
                    why is the individual needing services?  (Detailed member behavior/Current need for Treatment i..e. symptoms that are the focus of current treatment)
                    </span>

                    <textarea id="txt_Ongoing_Problem" name="txt_Ongoing_Problem" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Medical Conditions:   </span>
                    <span className='small'>
                    (does the Individual have any medical conditions that may contribute to the onset or progression of the Presenting Problem? If so, please explain in detail the medical condition and how the Individual is affected.)
                    </span>

                    <textarea id="txt_Medical_Conditions" name="txt_Medical_Conditions" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Medications:    </span>
                    <span className='small'>
                    (Please list all the medications the individual is taking whether orally, injection along with date prescribed, and if they are compliant
                    </span>

                    <textarea id="txt_Medications" name="txt_Medications" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Treatment History:   </span>
                    <span className='small'>
                    (Please list recent hospitalizations, previous treatment providers, etc.INCLUDING dates.
                    </span>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Date (s)</span></td>
                        <td className='w-150'><span className='eleHeader'>Location</span></td>
                        <td className='w-150'><span className='eleHeader'>Type of Treatment  </span><span className='small'>(Outpatient, Inpatient, etc)</span></td>
                        <td className='w-150'><span className='eleHeader'>Diagnosis Given</span></td>
                        <td className='w-150'><span className='eleHeader'>Outcome </span><span className='small'>(i.e., stabilized, withdrew from services, etc.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_1" name="txtDate_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_1" name="txtLocation_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_1" name="txtTreatment_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_1" name="txtDiagnosis_" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_1" name="txtOutcome_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_2" name="txtDate_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_2" name="txtLocation_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_2" name="txtTreatment_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_2" name="txtDiagnosis_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_2" name="txtOutcome_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_3" name="txtDate_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_3" name="txtLocation_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_3" name="txtTreatment_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_3" name="txtDiagnosis_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_3" name="txtOutcome_3" className='add-only' />
                        </td>
                    </tr>
                </table>

                
                </p>

    <p>
                    <span className='eleHeader'>Additional Clinical Information:    </span>
                    <span className='small'>
                    (Please list any additional information as needed)
                    </span>

                    <h5>Current Clinical Information (Please check all appropriate boxes that apply)</h5>




         <table>
               
               <tr>
                  <td className="w-300"><span className="eleHeader">Symptoms/Problems</span></td>
                  <td className="w-90"><span className="eleHeader">Mild</span></td>
                  <td className="w-90"><span className="eleHeader">Moderate</span></td>
                  <td className="w-90"><span className="eleHeader">  Severe</span></td>
                  <td className="w-90"><span className="eleHeader">  Acute</span></td>
                  <td className="w-90"><span className="eleHeader">Chronic</span></td>
                 
               </tr>
               <h4>Anxiety disorders</h4>
               <br />
               <tr>
                  <td className="w-300"><b>■ </b>Obsessions/compulsions</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Obsessions/compulsions1' name='chk_Obsessions/compulsions1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Obsessions/compulsions2' name='chk_Obsessions/compulsions2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Obsessions/compulsions3' name='chk_Obsessions/compulsions3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Obsessions/compulsions4' name='chk_Obsessions/compulsions4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Obsessions/compulsions5' name='chk_Obsessions/compulsions5'className='add-only' value="Chronic"/></td>
                  
                </tr>

                <br/>

                <tr>
                  <td className="w-300"><b>■ </b>Generalized anxiety</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Generalized_anxiet1' name='chk_Generalized_anxiet1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Generalized_anxiet2' name='chk_Generalized_anxiet2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Generalized_anxiet3' name='chk_Generalized_anxiet3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Generalized_anxiet4' name='chk_Generalized_anxiet4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Generalized_anxiet5' name='chk_Generalized_anxiet5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br/>

            <tr>
                  <td className="w-300"><b>■. </b> Panic attacks</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Panic_attacks1' name='chk_Panic_attacks1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Panic_attacks2' name='chk_Panic_attacks2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Panic_attacks3' name='chk_Panic_attacks3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Panic_attacks4' name='chk_Panic_attacks4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Panic_attacks5' name='chk_Panic_attacks5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br/>

            <tr>
                  <td className="w-300"><b>■. </b>  Phobias</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Phobias1' name='chk_Phobias1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Phobias2' name='chk_Phobias2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Phobias3' name='chk_Phobias3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Phobias4' name='chk_Phobias4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Phobias5' name='chk_Phobias5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br/>

            <tr>
                  <td className="w-300"><b>■. </b> Somatic complaints </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Somatic_complaints1' name='chk_Somatic_complaints1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Somatic_complaints2' name='chk_Somatic_complaints2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Somatic_complaints3' name='chk_Somatic_complaints3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Somatic_complaints4' name='chk_Somatic_complaints4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Somatic_complaints5' name='chk_Somatic_complaints5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br/>

            <tr>
                  <td className="w-300"><b>■. </b>  PTSD symptoms </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_PTSD_symptoms1' name='chk_PTSD_symptoms1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_PTSD_symptoms2' name='chk_PTSD_symptoms2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_PTSD_symptoms3' name='chk_PTSD_symptoms3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_PTSD_symptoms4' name='chk_PTSD_symptoms4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_PTSD_symptoms5' name='chk_PTSD_symptoms5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br/>

            <h4>Depression</h4>
            <br />
            <tr>
                  <td className="w-300"><b>■. </b>  Impaired concentration </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Impaired_concentration1' name='chk_Impaired_concentration1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Impaired_concentration2' name='chk_Impaired_concentration2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Impaired_concentration3' name='chk_Impaired_concentration3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Impaired_concentration4' name='chk_Impaired_concentration4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Impaired_concentration5' name='chk_Impaired_concentration5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Impaired memory </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Impaired_memory1' name='chk_Impaired_memory1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Impaired_memory2' name='chk_Impaired_memory2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Impaired_memory3' name='chk_Impaired_memory3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Impaired_memory4' name='chk_Impaired_memory4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Impaired_memory5' name='chk_Impaired_memory5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Psychomotor retardation </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Psychomotor_retardation1' name='chk_Psychomotor_retardation1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Psychomotor_retardation2' name='chk_Psychomotor_retardation2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Psychomotor_retardation3' name='chk_Psychomotor_retardation3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Psychomotor_retardation4' name='chk_Psychomotor_retardation4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Psychomotor_retardation5' name='chk_Psychomotor_retardation5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            
            <tr>
                  <td className="w-300"><b>■. </b>  Sexual issues </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Sexual_issues1' name='chk_Sexual_issues1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Sexual_issues2' name='chk_Sexual_issues2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Sexual_issues3' name='chk_Sexual_issues3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Sexual_issues4' name='chk_Sexual_issues4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Sexual_issues5' name='chk_Sexual_issues5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Appetite disturbancel  </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Appetite_disturbance1' name='chk_Appetite_disturbance1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Appetite_disturbance2' name='chk_Appetite_disturbance2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Appetite_disturbance3' name='chk_Appetite_disturbance3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Appetite_disturbance4' name='chk_Appetite_disturbance4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Appetite_disturbance5' name='chk_Appetite_disturbance5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Irritability </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Irritability1' name='chk_Irritability1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Irritability2' name='chk_Irritability2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Irritability3' name='chk_Irritability3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Irritability4' name='chk_Irritability4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Irritability5' name='chk_Irritability5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            
            <tr>
                  <td className="w-300"><b>■. </b>  Agitation </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Agitation1' name='chk_Agitation1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Agitation2' name='chk_Agitation2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Agitation3' name='chk_Agitation3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Agitation4' name='chk_Agitation4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Agitation5' name='chk_Agitation5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

              
            <tr>
                  <td className="w-300"><b>■. </b>  Sleep disturbance </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Sleep_disturbance1' name='chk_Sleep_disturbance1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Sleep_disturbance2' name='chk_Sleep_disturbance2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Sleep_disturbance3' name='chk_Sleep_disturbance3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Sleep_disturbance4' name='chk_Sleep_disturbance4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Sleep_disturbance5' name='chk_Sleep_disturbance5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

              
            <tr>
                  <td className="w-300"><b>■. </b> Hopelessness/helplessness </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Hopelessness_helplessness1' name='chk_Hopelessness_helplessness1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Hopelessness_helplessness2' name='chk_Hopelessness_helplessness2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Hopelessness_helplessness3' name='chk_Hopelessness_helplessness3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Hopelessness_helplessness4' name='chk_Hopelessness_helplessness4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Hopelessness_helplessness5' name='chk_Hopelessness_helplessness5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            
    <h4> Mania</h4>
            <br />
            <tr>
                  <td className="w-300"><b>■. </b>  Insomnia </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Insomnia1' name='chk_Insomnia1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Insomnia2' name='chk_Insomnia2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Insomnia3' name='chk_Insomnia3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Insomnia4' name='chk_Insomnia4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Insomnia5' name='chk_Insomnia5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Grandiosity </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Grandiosity1' name='chk_Grandiosity1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Grandiosity2' name='chk_Grandiosity2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='cchk_Grandiosity3' name='chk_Grandiosity3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Grandiosity4' name='chk_Grandiosity4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Grandiosity5' name='chk_Grandiosity5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Pressured speech </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Pressured_speech1' name='chk_Pressured_speech1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Pressured_speech2' name='chk_Pressured_speech2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Pressured_speech3' name='chk_Pressured_speech3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Pressured_speech4' name='chk_Pressured_speech4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Pressured_speech5' name='chk_Pressured_speech5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Racing thoughts/flight of ideas </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Racing_thoughts/flight_of_ideas1' name='chk_Racing_thoughts/flight_of_ideas1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Racing_thoughts/flight_of_ideas2' name='chk_Racing_thoughts/flight_of_ideas2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Racing_thoughts/flight_of_idea3' name='chk_Racing_thoughts/flight_of_ideas3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Racing_thoughts/flight_of_ideas4' name='chk_Racing_thoughts/flight_of_ideas4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Racing_thoughts/flight_of_ideas5' name='chk_Racing_thoughts/flight_of_ideas5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b> Poor judgment/impulsiveness </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Poor_judgment/impulsiveness1' name='chk_Poor_judgment/impulsiveness1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Poor_judgment/impulsiveness2' name='chk_Poor_judgment/impulsiveness2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Poor_judgment/impulsiveness4' name='chk_Poor_judgment/impulsiveness4'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Poor_judgment/impulsiveness4' name='chk_Poor_judgment/impulsiveness4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Poor_judgment/impulsiveness5' name='chk_Poor_judgment/impulsiveness5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <h4> Psychotic disorders</h4>
            <br />
            <tr>
                  <td className="w-300"><b>■. </b>  Delusions/paranoia</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Delusions/paranoia1' name='chk_Delusions/paranoia1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Delusions/paranoia2' name='chk_Delusions/paranoia2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Delusions/paranoia3' name='chk_Delusions/paranoia3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Delusions/paranoia4' name='chk_Delusions/paranoia4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Delusions/paranoia5' name='chk_Delusions/paranoia5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b> Self-care issues</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Self_care_issues1' name='chk_Self_care_issues1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Self_care_issues2' name='chk_Self_care_issues2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Self_care_issues3' name='chk_Self_care_issues3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Self_care_issues4' name='chk_Self_care_issues4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Self_care_issues5' name='chk_Self_care_issues5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>   Hallucinations </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Hallucinations1' name='chk_Hallucinations1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Hallucinations2' name='chk_Hallucinations2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='cchk_Hallucinations3' name='chk_Hallucinations3' className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Hallucinations4' name='chk_Hallucinations4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Hallucinations5' name='chk_Hallucinations5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Disorganized thought process</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Disorganized_thought_process1' name='chk_Disorganized_thought_process1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Disorganized_thought_process2' name='chk_Disorganized_thought_process2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='cchk_Disorganized_thought_process3' name='chk_Disorganized_thought_process3' className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Disorganized_thought_process4' name='chk_Disorganized_thought_process4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Disorganized_thought_process5' name='chk_Disorganized_thought_process5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            
            <tr>
                  <td className="w-300"><b>■. </b> Loose associations</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Loose_associations1' name='chk_Loose_associations1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Loose_associations2' name='chk_Loose_associations2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Loose_associations3' name='chk_Loose_associations3' className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Loose_associations4' name='chk_Loose_associations4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Loose_associations5' name='chk_Loose_associations5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <h4>Substance abuse</h4>
            <br />
            <tr>
                  <td className="w-300"><b>■. </b>  Loss of control of dosage </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Loss_control_dosage1' name='chk_Loss_control_dosage1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Loss_control_dosage2' name='chk_Loss_control_dosage2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Loss_control_dosage3' name='chk_Loss_control_dosage3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Loss_control_dosage4' name='chk_Loss_control_dosage4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Loss_control_dosage5' name='chk_Loss_control_dosage5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b> Amnesic episodes </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Loss_Amnesic_episodes1' name='chk_Loss_Amnesic_episodes1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Loss_Amnesic_episodes2' name='chk_Loss_Amnesic_episodes2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Loss_Amnesic_episodes3' name='chk_Loss_Amnesic_episodes3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Loss_Amnesic_episodes4' name='chk_Loss_Amnesic_episodes4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Loss_Amnesic_episodes5' name='chk_Loss_Amnesic_episodes5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b> Legal Problems </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Legal_Problems1' name='chk_Legal_Problems1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Legal_Problems2' name='chk_Legal_Problems2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Legal_Problems3' name='chk_Legal_Problems3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Legal_Problems4' name='chk_Legal_Problems4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Legal_Problems5' name='chk_Legal_Problems5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            
            <tr>
                  <td className="w-300"><b>■. </b> Alcohol abuse </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Alcohol_abuse1' name='chk_Alcohol_abuse1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Alcohol_abuse2' name='chk_Alcohol_abuse2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Alcohol_abuse3' name='chk_Alcohol_abuse3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Alcohol_abuse4' name='chk_Alcohol_abuse4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Alcohol_abuse5' name='chk_Alcohol_abuse5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b> Opiate abuse </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Opiate_abuse1' name='chk_Opiate_abuse1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Opiate_abuse2' name='chk_Opiate_abuse2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Opiate_abuse3' name='chk_Opiate_abuse3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Opiate_abuse4' name='chk_Opiate_abuse4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Opiate_abuse5' name='chk_Opiate_abuse5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b> Prescription medication abuse </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Prescription_medication_abuse1' name='chk_Prescription_medication_abuse1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Prescription_medication_abuse2' name='chk_Prescription_medication_abuse2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Prescription_medication_abuse3' name='chk_Prescription_medication_abuse3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Prescription_medication_abuse4' name='chk_Prescription_medication_abuse4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Prescription_medication_abuse5' name='chk_Prescription_medication_abuse5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            
            <tr>
                  <td className="w-300"><b>■. </b> Polysubstance abuse </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Polysubstance_abuse1' name='chk_Polysubstance_abuse1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Polysubstance_abuse2' name='chk_Polysubstance_abuse2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Polysubstance_abuse3' name='chk_Polysubstance_abuse3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Polysubstance_abuse4' name='chk_Polysubstance_abuse4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Polysubstance_abuse5' name='chk_Polysubstance_abuse5'className='add-only' value="Chronic"/></td>

            </tr>

            <br />

            <h4>Personality Disorder</h4>
            <br />
            <tr>
                  <td className="w-300"><b>■. </b>  Oddness/eccentricities </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Oddness/eccentricities1' name='chk_Oddness/eccentricities1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Oddness/eccentricities2' name='chk_Oddness/eccentricities2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Oddness/eccentricities3' name='chk_Oddness/eccentricities3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Oddness/eccentricities4' name='chk_Oddness/eccentricities4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Oddness/eccentricities5' name='chk_Oddness/eccentricities5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Oppositional </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Oppositional1' name='chk_Oppositional1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Oppositional2' name='chk_Oppositional2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Oppositional3' name='chk_Oppositional3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Oppositional4' name='chk_Oppositional4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Oppositional5' name='chk_Oppositional5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>  Disregard for RULES </td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Disregard_for_RULES1' name='chk_Disregard_for_RULES1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Disregard_for_RULES2' name='chk_Disregard_for_RULES2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Disregard_for_RULES3' name='chk_Disregard_for_RULES3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Disregard_for_RULES4' name='chk_Disregard_for_RULES4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Disregard_for_RULES5' name='chk_Disregard_for_RULES5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b>   Recurring self-injuries</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Recurring_self_injuries1' name='chk_Recurring_self_injuries1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Recurring_self_injuries2' name='chk_Recurring_self_injuries2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Recurring_self_injuries3' name='chk_Recurring_self_injuries3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Recurring_self_injuries4' name='chk_Recurring_self_injurie4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Recurring_self_injuries5' name='chk_Recurring_self_injuries5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            
            <tr>
                  <td className="w-300"><b>■. </b>  Sense of entitlement</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Sense_of_entitlement1' name='chk_Sense_of_entitlement1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Sense_of_entitlement2' name='chk_Sense_of_entitlement2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Sense_of_entitlement3' name='chk_Sense_of_entitlement3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Sense_of_entitlement4' name='chk_Sense_of_entitlement4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Sense_of_entitlement5' name='chk_Sense_of_entitlement5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

             
            <tr>
                  <td className="w-300"><b>■. </b>  Passive aggressive</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Passive_aggressive1' name='chk_Passive_aggressive1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Passive_aggressive2' name='chk_Passive_aggressive2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Passive_aggressive3' name='chk_Passive_aggressive3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Passive_aggressive4' name='chk_Passive_aggressive4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Passive_aggressive5' name='chk_Passive_aggressive5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            <tr>
                  <td className="w-300"><b>■. </b> Dependency</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Dependency1' name='chk_Dependency1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Dependency2' name='chk_Dependency2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Dependency3' name='chk_Dependency3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Dependency4' name='chk_Dependency4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Dependency5' name='chk_Dependency5'className='add-only' value="Chronic"/></td>
                  
            </tr>

            <br />

            
            <tr>
                  <td className="w-300"><b>■. </b> Enduring traits of:</td>
                  <td className="w-70 text-center">
                  <input type='checkbox' id='chk_Enduring_traits1' name='chk_Enduring_traits1'className='add-only' value="Mild"/></td>
                  <td className="w-130 text-center">
                  <input type='checkbox' id='chk_Enduring_traits2' name='chk_Enduring_traits2'className='add-only' value="Moderate"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Enduring_traits3' name='chk_Enduring_traits3'className='add-only' value="Severe"/></td>
                  <td className="w-80 text-center">
                  <input type='checkbox' id='chk_Enduring_traitsy4' name='chk_Enduring_traits4'className='add-only' value="Acute"/></td>
                  <td className="w-90 text-center">
                  <input type='checkbox' id='chk_Enduring_traits5' name='chk_Enduring_traits5'className='add-only' value="Chronic"/></td>
                  
            </tr>

        </table>
        <br />
        <br />

        <table>
            <h4>
                REQUESTED AUTHORIZATION: 
            </h4>
        <tr>
                        <td className='w-120'>Procedure Code: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Procedure_Code" name="txt_Procedure_Code" className='add-only' />
                        </td>

                        
                        <td className='w-120'>Number of Units:  </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Numbe_of_Units" name="txt_Numbe_of_Units" className='add-only' />
                        </td>

                         
                        <td className='w-90'>Frequency: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Frequency" name="txt_Frequency" className='add-only' />
                        </td>

                         
                        <td className='w-120'>Units Approved: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Units_Approved" name="txt_Units_Approved" className='add-only' />
                        </td>
                        
                        
        </tr>

        <tr>
                        <td className='w-120'>Procedure Code: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Procedure_Code" name="txt_Procedure_Code" className='add-only' />
                        </td>

                        
                        <td className='w-120'>Number of Units:  </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Numbe_of_Units" name="txt_Numbe_of_Units" className='add-only' />
                        </td>

                         
                        <td className='w-90'>Frequency: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Frequency" name="txt_Frequency" className='add-only' />
                        </td>

                         
                        <td className='w-120'>Units Approved: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Units_Approved" name="txt_Units_Approved" className='add-only' />
                        </td>
                        
                        
        </tr>

        <tr>
                        <td className='w-120'>Procedure Code: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Procedure_Code" name="txt_Procedure_Code" className='add-only' />
                        </td>

                        
                        <td className='w-120'>Number of Units:  </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Numbe_of_Units" name="txt_Numbe_of_Units" className='add-only' />
                        </td>

                         
                        <td className='w-90'>Frequency: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Frequency" name="txt_Frequency" className='add-only' />
                        </td>

                         
                        <td className='w-120'>Units Approved: </td>
                        <td className='w-80'>
                            <input type="text" id="txt_Units_Approved" name="txt_Units_Approved" className='add-only' />
                        </td>

                   
                        
                        
        </tr>

        <tr>
                        <td className='w-90'> Start Date</td>
                        <td className='w-200'>
                            <input type="date" id="dt_Start_Date" name="txt_Start_Date" className='add-only' />
                        </td>

                       <td className='w-120'> </td>

                        
                        <td className='w-90'> End Date:</td>
                        <td className='w-200'>
                            <input type="date" id="dt_End_Date" name="txt_End_Date" className='add-only' />
                        </td>

                        

                   
                        
                        
        </tr>

        

        
        </table>


        <h3>COMPLETED BY:</h3>
                <p>
                    <span className='small'>(Please include credentials after your name)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Assessor Signature:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Assessor Print Name:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                </table>
                <h3>REVIEWED BY </h3>
                <span className='small'>(If Applicable):</span>
                <p>
                    <span className='small'>(Please include credentials after your name)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Licensed Professional Signature:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Licensed Professional Print Name:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                </table>










            



            

            






               
          

                </p>


              


                









               

                
                


                


            </div>
        </form>

    )
}